import React from 'react';

interface MCPStatusBadgeProps {
  showLabel?: boolean;
  compact?: boolean;
}

const MCPStatusBadge: React.FC<MCPStatusBadgeProps> = ({
  showLabel = true,
  compact = false
}) => {
  // Always return null to hide the badge entirely
  return null;
};

export default MCPStatusBadge;
